import $ from 'jquery';

$(function() {
  $(document).on('click', '.show-more', function(e) {
    e.preventDefault();
    const _this = $(this);
    const logoWall = $( '.logo-wall' );

    _this.addClass( 'hide' );
    logoWall.css( 'max-height', logoWall[0].scrollHeight );
    logoWall.find( '.load-more-scrim' ).addClass( 'hide' );
  })
})